import { useLocation } from "react-router-dom";

// The admin Clients/Business pages are reused under /me for employees who
// have client.* permissions. Anywhere we navigate within those pages, the
// destination has to stay inside the active scope or breadcrumb back-links
// would dump employees out of their route tree.
//
// Returns the leading segment of the current pathname when it's "/admin" or
// "/me" — anything else falls back to "/admin" so admin entry paths still
// resolve. Use like:
//   const base = useScopedBase();
//   navigate(`${base}/clients/${id}`);
export default function useScopedBase() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/me/")) return "/me";
  if (pathname === "/me") return "/me";
  return "/admin";
}
